// import _ from 'lodash';
import debug from '../../services/debug';
import {
  SET_CONTACT_REDIRECTROUTE_REQUESTED,
  // SET_CONTACT_REDIRECT_ABORTED,
  SET_CONTACT_REDIRECTROUTE_COMPLETED,
  SET_CONTACT_REDIRECTROUTE_FAILED,
} from './types';

const setContactRedirectRoute = async (Command) => async (dispatch) => {
  // const { contacts } = getState();

  // const contact = contacts.get('set');
  // if (_.isEmpty(contact) && contact.ContactID === 0) {
  //     return dispatch({
  //         type: SET_CONTACT_REDIRECT_ABORTED,
  //     });
  // }

  dispatch({
    type: SET_CONTACT_REDIRECTROUTE_REQUESTED,
  });

  try {
    dispatch({
      type: SET_CONTACT_REDIRECTROUTE_COMPLETED,
      payload: Command,
    });
  } catch (err) {
    debug(SET_CONTACT_REDIRECTROUTE_FAILED, err);

    dispatch({
      type: SET_CONTACT_REDIRECTROUTE_FAILED,
      payload: err,
    });
  }
};

export default setContactRedirectRoute;
